import "./dashboard.scss";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardData } from "../../redux/actions/dashboardActions";
import LatestReports from "../../components/LatestReports/LatestReports";
import Menu from "../../components/Menu/Menu";
import Stats from "../../components/Stats/Stats";
import Sessions from "../../components/Sessions/Sessions";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: dashboardData } = useSelector((state) => state.dashboard);

  useEffect(() => {
    const loadData = async () => {
      try {
        dispatch(fetchDashboardData(navigate)); // Pasa navigate como argumento
      } catch (error) {
        console.error(error);
      }
    };

    loadData();
  }, [dispatch, navigate]);

  return (
    <div className="dashboard">
      <div className="profile-column">
        <Menu dashboardData={dashboardData} />
      </div>
      <div className="content-column">
        <div className="stats-sessions">
          <Stats dashboardData={dashboardData} />
          <Sessions dashboardData={dashboardData} />
        </div>
        <LatestReports dashboardData={dashboardData} />
      </div>
    </div>
  );
};

export default Dashboard;
